$(document).ready(function(){

	$('a[href^="#"]').on('click', function(e){
		e.preventDefault();
		
		var id = $(this).attr("href");
	
		$('html, body').animate({
			scrollTop: $(id).offset().top - $('.header').outerHeight() - 30
		}, 'slow');

		$(id).focus();

		return false;
	});

});